import React from 'react';
import { Stack, TextField, Typography, InputAdornment } from '@mui/material';
import { TransactionDetailSectionProps } from '../../../@types/transactions';

const TransactionDetailSection: React.FC<TransactionDetailSectionProps> = ({
  values,
  touched,
  errors,
  getFieldProps,
  setFieldValue,
  isEdit
}) => (
  <>
    <Typography variant="h6" gutterBottom>
      Transaction Detail
    </Typography>

    <Stack direction="row" spacing={2}>
      <TextField
        fullWidth
        label="Weight 1 Seq No"
        disabled={isEdit}
        {...getFieldProps('Weight1SeqNo')}
        error={Boolean(touched.Weight1SeqNo && errors.Weight1SeqNo)}
        helperText={touched.Weight1SeqNo && errors.Weight1SeqNo}
      />

      <TextField
        fullWidth
        label="Weight 1 Date*"
        type="text"
        placeholder="DD-MM-YYYY"
        value={values.Weight1Date}
        onChange={(e) => {
          setFieldValue && setFieldValue('Weight1Date', e.target.value);
        }}
        error={Boolean(touched.Weight1Date && errors.Weight1Date)}
        helperText={touched.Weight1Date && errors.Weight1Date}
      />

      <TextField
        fullWidth
        label="Weight 1 Time*"
        type="text"
        placeholder="HH:MM"
        value={values.Weight1Time}
        onChange={(e) => {
          setFieldValue && setFieldValue('Weight1Time', e.target.value);
        }}
        error={Boolean(touched.Weight1Time && errors.Weight1Time)}
        helperText={touched.Weight1Time && errors.Weight1Time}
      />

      <TextField
        fullWidth
        type="number"
        label="Weight 1 Value (KG)*"
        {...getFieldProps('Weight1Value')}
        error={Boolean(touched.Weight1Value && errors.Weight1Value)}
        helperText={touched.Weight1Value && errors.Weight1Value}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: <InputAdornment position="end">KG</InputAdornment>
        }}
      />
    </Stack>

    <Stack direction="row" spacing={2}>
      <TextField
        fullWidth
        label="Weight 2 Seq No"
        disabled={isEdit}
        {...getFieldProps('Weight2SeqNo')}
        error={Boolean(touched.Weight2SeqNo && errors.Weight2SeqNo)}
        helperText={touched.Weight2SeqNo && errors.Weight2SeqNo}
      />

      <TextField
        fullWidth
        type="text"
        label="Weight 2 Date*"
        placeholder="DD-MM-YYYY"
        value={values.Weight2Date}
        onChange={(e) => {
          setFieldValue && setFieldValue('Weight2Date', e.target.value);
        }}
        error={Boolean(touched.Weight2Date && errors.Weight2Date)}
        helperText={touched.Weight2Date && errors.Weight2Date}
      />

      <TextField
        fullWidth
        type="text"
        label="Weight 2 Time*"
        placeholder="HH:MM"
        value={values.Weight2Time}
        onChange={(e) => {
          setFieldValue && setFieldValue('Weight2Time', e.target.value);
        }}
        error={Boolean(touched.Weight2Time && errors.Weight2Time)}
        helperText={touched.Weight2Time && errors.Weight2Time}
      />

      <TextField
        fullWidth
        type="number"
        label="Weight 2 Value (KG)*"
        {...getFieldProps('Weight2Value')}
        error={Boolean(touched.Weight2Value && errors.Weight2Value)}
        helperText={touched.Weight2Value && errors.Weight2Value}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: <InputAdornment position="end">KG</InputAdornment>
        }}
      />
    </Stack>

    <Stack direction="row" spacing={2}>
      <TextField
        fullWidth
        label="Client Ref"
        {...getFieldProps('ClientRef')}
        error={Boolean(touched.ClientRef && errors.ClientRef)}
        helperText={touched.ClientRef && errors.ClientRef}
      />
      <TextField
        fullWidth
        label="Net Weight (KG)"
        value={values.WeightNet || 0}
        disabled
        InputProps={{
          endAdornment: <InputAdornment position="end">KG</InputAdornment>
        }}
      />
    </Stack>
  </>
);

export default TransactionDetailSection;
